<script setup>
import { inject } from "vue";

const bulk_upload_response = inject("bulk_upload_response");
</script>
<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">UPLOADED DEVICES</h3>
            </div>
            <div class="card-body" x-data="filter-options">
              <div class="row">
                <label
                  v-if="bulk_upload_response.uploadedData?.length !== 0"
                  style="color: green"
                >
                  {{ bulk_upload_response.uploadedData?.length }}
                  device{{
                    bulk_upload_response.uploadedData?.length === 1 ? "" : "s"
                  }}
                  uploaded.
                </label>
                <table
                  v-if="bulk_upload_response.uploadedData?.length !== 0"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th>ROW NO.</th>
                      <th>IMEI</th>
                      <th>ICCID</th>
                      <th>MSISDN</th>
                      <th>Device Class</th>
                      <th>Device Type</th>
                      <th>Provider</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="uploaded in bulk_upload_response.uploadedData"
                      :key="uploaded.row"
                    >
                      <td>{{ uploaded.row }}</td>
                      <td>{{ uploaded.imei }}</td>
                      <td>{{ uploaded.iccid }}</td>
                      <td>{{ uploaded.msisdn }}</td>
                      <td>{{ uploaded.device_class }}</td>
                      <td>{{ uploaded.device_type }}</td>
                      <td>{{ uploaded.provider }}</td>
                    </tr>
                  </tbody>
                </table>

                <div v-else style="color: red; font-weight: bold">
                  No Device Were Uploaded
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
